<template>
  <div id="baseapp">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.getLangeInfo();
  },
  methods: {
    async getLangeInfo() {
      await this.$store.dispatch("config/getLangList");
      await this.$store.dispatch("config/getLangData");
    },
  },
};
</script>
<style lang="scss">
#baseapp {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>
